import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { NavController } from "@ionic/angular";
import { quickWebLogger } from "@quickweb/logger";
import { AnalyticsAdjustPagesModel } from "src/app/shared/service/analytics-adjust-pages/analytics-adjust-pages-models";
import { environment } from "../../../../environments/environment";
import { DefaultPageComponent } from "../../../shared/page/default-page.component";
import { AnalyticsAdjustPageService } from "../../../shared/service/analytics-adjust-pages/analytics-adjust-page.service";
import { AnalyticsGA4PageService } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";
import { AnalyticsGA4PagesModel } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models";
import { BackNativeService } from "../../../shared/service/comunicator-native/back-native/back-native";
import { ReturnNativeService } from "../../../shared/service/comunicator-native/return-native/return-native";
import { DomainFactoryService } from "../../../shared/service/domains/domain-factory-service";
import { DomainDataType } from "../../../shared/service/domains/model/domain-data-type";
import { DomainOrigin } from "../../../shared/service/domains/model/domain-origin";
import { JourneyService } from "../../../shared/service/journey/journey.service";
import { LogService } from "../../../shared/service/log/log.service";
import { ProgressStep } from "../../model/progress-step";

@Component({
  selector: "app-overview",
  templateUrl: "./overview.component.html",
  styleUrls: ["./overview.component.scss"],
})
export class OverviewComponent extends DefaultPageComponent implements OnInit {
  @ViewChild("buttonBack") buttonBack!: ElementRef<HTMLElement>;
  steps;

  headerId = "overview";
  titlePage = "Cadastro íon";
  startStage = "1";
  endStage = "1";
  statusToken = "";
  title = "";
  subTitle = "";
  message =
    "Separe alguns minutos para finalizar seu cadastro, pois não salvamos seus dados a cada etapa.";
  status = "";

  hasToken = false;
  hasLinks = false;
  hasDomains = false;
  analyticsPageGA4: AnalyticsGA4PagesModel;
  idButtonOverView = "buttonOverView";
  idMessageOverView = "idMessageOverView";
  idStepsOverView = "idStepsOverView";
  analyticsPageAdjust: AnalyticsAdjustPagesModel;
  loading = true;
  domainsForQadomain = [
    DomainDataType.DocumentType,
    DomainDataType.Gender,
    DomainDataType.Profession,
    DomainDataType.DocumentIssuing,
    DomainDataType.OriginIncome,
    DomainDataType.Nationality,
    DomainDataType.MaritalStatus,
  ];

  domainsForDomainRoot = [DomainDataType.State, DomainDataType.Country];

  public domainDataType: DomainDataType = DomainDataType.City;

  constructor(
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    public router: NavController,
    private logService: LogService,
    public domainFactory: DomainFactoryService,
    public returnNativeService: ReturnNativeService,
    private analyticsGA4PageService: AnalyticsGA4PageService,
    private analyticsAdjustPageService: AnalyticsAdjustPageService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPageGA4();
    this.getAnalyticsPageAdjust();
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.sendTrackGA4LoadPage();
    this.sendTrackAdjustLoadPage();
  }

  async ngOnInit() {
    localStorage.clear();
    sessionStorage.clear();

    if ("caches" in window) {
      const cacheNames = await caches.keys();
      for (const cacheName of cacheNames) {
        await caches.delete(cacheName);
      }
    }
    this.headerFocus();
    // GET CITIES BY STATES
    const states = ["SP", "RJ", "BA", "MG", "RS"];
    this.getCities(states);
    this.getDomains();
    this.status = "";
    this.logService.save(
      "Solicitanto token",
      "OverviewComponent.ionViewWillEnter"
    );
    this.getAllDomains();
    this.title =
      this.journeyService.registratioJourney?.data?.personalData?.name +
      ", agora precisamos de mais informações.";
    this.steps = [
      new ProgressStep(
        "assets/images/svg/dados-pessoais.svg",
        "Dados pessoais"
      ),
      new ProgressStep("assets/images/svg/estado-civil.svg", "Estado civil"),
      new ProgressStep("assets/images/svg/endereco.svg", "Endereço"),
      new ProgressStep(
        "assets/images/svg/dados-profissionais.svg",
        "Dados profissionais"
      ),
      new ProgressStep("assets/images/svg/renda.svg", "Renda e patrimônio"),
    ];
    setTimeout(() => {
      this.loading = false;
    }, 5000);
    quickWebLogger.rum.startView({
      pageName: `${this.journeyService.journey}/${location.hash}`,
    });
  }

  private async getAllDomains() {
    this.status += "-- Carregando Domínios --";
    this.logService.save(
      "carregando domínios",
      "OverviewComponent.getAllDomains"
    );

    await this.domainFactory
      .getDomainService(DomainOrigin[environment.contaIonDomainOrigin])
      .getDomains(this.domainsForQadomain);

    this.logService.save(
      "Todos os domínios carregados",
      "OverviewComponent.getAllDomains"
    );
  }

  private async getDomains() {
    this.status += "-- Carregando Domínios --";
    this.logService.save(
      "carregando domínios",
      "OverviewComponent.getAllDomains"
    );

    await Promise.all(
      this.domainsForDomainRoot.map(async (domain) => {
        try {
          await this.domainFactory
            .getDomainService(DomainOrigin[environment.contaIonDomainOrigin])
            .getDomains(domain);
          this.logService.save(
            `Domínio carregado: ${domain}`,
            "OverviewComponent.getAllDomains"
          );
        } catch (error) {
          this.logService.save(
            `Erro ao carregar domínio: ${domain} - ${JSON.stringify(error)}`,
            "OverviewComponent.getAllDomains"
          );
        }
      })
    );

    this.logService.save(
      "Todos os domínios carregados",
      "OverviewComponent.getAllDomains"
    );
  }

  private async getCities(states) {
    this.logService.save("carregando cidades ", "OverviewComponent.getCities");
    for (const state of states) {
      try {
        await this.domainFactory
          .getDomainService(DomainOrigin[environment.contaIonDomainOrigin])
          .getDomains(this.domainDataType, state);
      } catch (error) {
        this.logService.save(
          `Erro carregar Cidades - ${state} -  ${JSON.stringify(error)}`,
          "OverviewComponent.getCities"
        );
      }

      this.logService.save(
        "Cidades carregadas ",
        "OverviewComponent.getCities"
      );
    }
  }

  getPageId(): string {
    return this.headerId;
  }

  clickNext() {
    this.nextPage();
  }

  checkLastItem(step: ProgressStep): boolean {
    const index = this.steps.findIndex((r) => r.label === step.label);
    const stepLenght = this.steps.length - 1;
    return index == stepLenght;
  }

  showStatus() {
    return false;
    //return (!environment.production || environment.id === 'dev' || environment.id === 'staging');
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  getAnalyticsPageAdjust() {
    this.analyticsPageAdjust =
      this.analyticsAdjustPageService.setAnalyticsPageAdjust();
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathConfiraSeusDados,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  sendTrackAdjustLoadPage() {
    const paramDefautl = {
      it_token: this.analyticsPageAdjust.criarconta_perfil_tudocerto,
    };

    this.analyticsAdjustPageService.sendTrackAdjust(paramDefautl);
  }
}
